<div class="dialog-popover-container">
  <div class="dialog-popover-heading">
    <h3 mat-dialog-title class="dialog-title">{{data?.type | titlecase}}</h3>
    <button class="close-button">
      <mat-icon mat-dialog-close class="close-icon">close</mat-icon>
    </button>
  </div>
  <div class="content-background" [formGroup]="formGroup">
    <div *ngIf="data?.type === 'Add Devices'" class="dialogpopover-content">
      <mat-form-field appearance="outline">
        <mat-label>No Of Devices</mat-label>
        <div class="input-box-container">
          <input matInput type="number" formControlName="noOfDevices" (keypress)="numberOnly($event)"
            autocomplete="disabled" (paste)="(false)" class="input-arrow">
        </div>
      </mat-form-field>
      <mat-error *ngIf="noOfDevices.hasError('min')" class="pt-0">Minimum value is {{minNoOfDevices}}</mat-error>
      <mat-error *ngIf="noOfDevices.hasError('max')" class="pt-0">Maximum value is {{maxNoOfDevices}}</mat-error>
    </div>

    <mat-dialog-content
      *ngIf="data?.type === 'Delete Device' || data?.type === 'Delete Batch' || data?.type === 'Batch Run' || data?.type === 'Delete Template'">
      <div class="delete-description-container">
        <span>Are you sure you want to </span>
        <span>{{data?.msg}}</span>
      </div>
    </mat-dialog-content>

    <div class="info-container">
      <span *ngIf="data?.type === 'Delete Device'" class="info-details"><span class="info-text">Info:</span>Please make
        sure devices are detached from batches.</span>
    </div>
  </div>
  <div class="btn-container">
    <button mat-button mat-dialog-close>{{data?.buttonText?.cancel}}</button>
    <button mat-button [disabled]="(data?.type === 'Add Devices') && !noOfDevices.valid" class="echo-btn-common-done"
      (click)="save()">{{data.buttonText.ok}}</button>
  </div>
</div>